import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d006b04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component-recaptcha" }

import { onMounted, ref, nextTick, watch } from 'vue';
  import { loadScript } from 'vue-plugin-load-script';

  interface IProps {
    modelValue: string;
  }
  interface IEmits {
    (event: 'update:modelValue', modelValue: string): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: string): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: string;
  }

  
  

  onMounted(requestRecaptcha);

  const grecaptchaContainer = ref();
  async function requestRecaptcha() {
    await loadScript('https://www.google.com/recaptcha/api.js?render=explicit');
    grecaptcha.ready(() => {
      grecaptcha.render(grecaptchaContainer.value as HTMLDivElement, {
        sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY,
        callback: token => {
          emits('update:modelValue', token);
        },
        'expired-callback'() {
          reset();
        }
      });
    });
  }

  const renderRecaptcha = ref(true);
  async function reset() {
    emits('update:modelValue', '');
    renderRecaptcha.value = false;
    await nextTick();
    renderRecaptcha.value = true;
    await nextTick();
    requestRecaptcha();
  }

  expose({
    reset
  });

  watch(() => props.modelValue, (modelValue) => {
    if (!modelValue) {
      reset();
    }
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (renderRecaptcha.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "grecaptchaContainer",
          ref: grecaptchaContainer
        }, null, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})